import { useEffect, useRef } from "react";
import { recordConversationAccess, getPersonalChatKeyFromSyntheticConversationId } from "../../../api/client";
import { shouldRecordLeadAccess } from "./leadAccessRecordPolicy";

function isDocumentReload() {
  try {
    const nav = performance.getEntriesByType?.("navigation")?.[0];
    return nav?.type === "reload";
  } catch {
    return false;
  }
}

/**
 * Registra acesso LGPD ao abrir uma solicitação.
 * Recarregar a mesma URL não dispara POST.
 * Trocar de solicitação dispara um POST leve; o servidor só persiste se houver informação nova.
 */
export default function useRecordLeadAccess({
  selectedConversationId,
  routeLeadId = null,
  origem = "chat",
}) {
  const sessionRef = useRef({
    didHandleInitialReload: false,
    lastRecordedLeadId: null,
  });
  const initialRouteLeadIdRef = useRef(routeLeadId != null ? String(routeLeadId) : null);

  useEffect(() => {
    if (!selectedConversationId) return;
    if (getPersonalChatKeyFromSyntheticConversationId(selectedConversationId)) return;

    const leadId = Number(selectedConversationId);
    if (!Number.isFinite(leadId) || leadId <= 0) return;

    const decision = shouldRecordLeadAccess({
      didHandleInitialReload: sessionRef.current.didHandleInitialReload,
      lastRecordedLeadId: sessionRef.current.lastRecordedLeadId,
      leadId,
      isReload: isDocumentReload(),
      initialRouteLeadId: initialRouteLeadIdRef.current,
    });
    sessionRef.current.didHandleInitialReload = decision.didHandleInitialReload;
    sessionRef.current.lastRecordedLeadId = decision.lastRecordedLeadId;
    if (!decision.record) return;

    recordConversationAccess(leadId, { origem }).catch(() => {});
  }, [selectedConversationId, origem]);
}
